import React, { Component } from 'react';

// import Custom Componenets
import Breadcrumb from '../common/breadcrumb.component';
import BootstrapTable from 'react-bootstrap-table-next';
import Modal from 'react-responsive-modal';
import { Button, Form, FormGroup, Label, Col } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';

// koneksi
import { GetLanding } from '../../function/Koneksi';

// css files
// import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';

const formInput = {
	uuid:'',
	nama_usaha: '',
	jenis_usaha: '',
	no_telp_usaha: '',
	alamat_usaha: '',
	email_usaha: '',
	id_provinsi: '',
	id_kabkota: '',
	nama_penanggung_jawab: '',
	no_telp_penanggung_jawab: '',
	email_penanggung_jawab: '',
	file_ktp_penanggung_jawab: '',
	file_npwp_perusahaan: '',
	file_siup_perusahaan: '',
	no_siup: '',
	no_npwp_perusahaan: '',
	alamat_perusahaan_npwp: '',
}

class Partner extends Component {

	constructor(props) {
		super(props);
		this.loader = props;
		this.state = {
			data: [],
			pagination: [],
			status: {
				form: false,
				btnForm: false,
				btnAksi: false,
				detail: false,
			},
			awal: "",
			sebelum: "",
			hal: [],
			setelah: "",
			akhir: "",
			dt: formInput,
			judul: "Tambah Version App",
			alert: null,
			show: false,
			basicTitle: '',
			basicType: "default",
			pesanAlert: '',
			dataCari: '',
			loadingPreview: false,
			//ckeditor
			content: '',
			responnya: [],
			
			frmJenisApp: [],
		};
	}

	// ================== Sweet Alert ==================
	closeAlert = () => {
		this.setState({
			show: false
		});
	}

	onRecieveInput = (value) => {
		this.setState({
			alert: (
				<SweetAlert success title="Nice!" onConfirm={this.hideAlert}>
					You wrote: {value}
				</SweetAlert>
			)
		});
	}

	hideAlert = () => {
		this.setState({
			alert: null
		});
	}

	// =================================================

	// ================== Ambil data dari db untuk table ==================
	fetch = (params = {}) => {
		this.setState({
			loadingPreview: true,
		})
		let link = "";
		if (params.page) {
			switch (params.page) {
				case ">>":
				  link =
					"?page=" +
					Math.ceil(
					  this.state.pagination.total / this.state.pagination.per_page
					);
				  break;
				case ">":
				  link = "?page=" + (parseInt(this.state.pagination.current_page) + 1);
				  break;
				case "<":
				  link = "?page=" + (parseInt(this.state.pagination.current_page) - 1);
				  break;
				case "<<":
				  link = "?page=1";
				  break;
				default:
				  link = "?page=" + params.page;
				  break;
			  }
		}

		if(params.page){
			link = link + '&q=' + this.state.dataCari	
		}
		else{
			link = link + '?q=' + this.state.dataCari	
		}

		GetLanding('partner' + link, null, (lihat) => {
			if (lihat.results.data) {
				this.setState({ 
					data: lihat.results.data, 
					pagination: lihat.results,
					loadingPreview: false
				});

				if (lihat.results.data.length > 0) {
					this.setState({
						dt: {
							...this.state.dt,
							file_ktp_penanggung_jawab: lihat.results.data[0].file_ktp_penanggung_jawab,
							file_npwp_perusahaan: lihat.results.data[0].file_npwp_perusahaan,
							file_siup_perusahaan: lihat.results.data[0].file_siup_perusahaan,
						}
					});
				}

				this.pagination(lihat.results);
			}
			else{
				this.setState({ loadingPreview: false, });
			}
		});
	}

	// Pagination
	pagination = (data, tab) => {
		let awal = "";
		let hal = [];
		let sebelum = "";
		let setelah = "";
		let akhir = "";
		if (data.total > 0) {
		  let start = 1;
		  let end = 5;
		  let n = 0;
		  let p = 0;
		  if (data.current_page <= 3) {
			start = 1;
			end = 5;
			if (data.last_page > data.current_page) {
			  n = data.current_page + 1;
			}
		  } else {
			p = data.current_page - 1;
			n = data.current_page + 1;
			start = data.current_page - 2;
			end = data.current_page + 2;
		  }
		  if (end >= data.last_page - 2) {
			p = data.current_page - 1;
			if (start >= 5) {
			  start = data.last_page - 4;
			}
			end = data.last_page;
		  }
	
		  for (let i = start; i <= end; i++) {
			let warna = "success";
			if (i === data.current_page) {
			  warna = "danger";
			}
			hal.push(
			  <a
				href={() => false}
				key={i}
				onClick={() => this.fetch({ page: i, tab: tab })}
				className={
				  "btn btn-" + warna + " btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
				}
			  >
				{i}
			  </a>
			);
		  }
		  if (p > 0) {
			sebelum = (
			  <a
				href={() => false}
				onClick={() => this.fetch({ page: p, tab: tab })}
				className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			  >
				{"<"}
			  </a>
			);
		  }
		  if (n > 0) {
			setelah = (
			  <a
				href={() => false}
				onClick={() => this.fetch({ page: n, tab: tab })}
				className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			  >
				{">"}
			  </a>
			);
		  }
	
		  awal = (
			<a
			  href={() => false}
			  onClick={() => this.fetch({ page: 1, tab: tab })}
			  className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			>
			  {"<<"}
			</a>
		  );
		  akhir = (
			<a
			  href={() => false}
			  onClick={() => this.fetch({ page: data.last_page, tab: tab })}
			  className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			>
			  {">>"}
			</a>
		  );
		}
	
		
		this.setState({ awal, sebelum, hal, setelah, akhir });
		
	};

	// Cari Data Table
	cariData = e => {
		if (e.key === 'Enter') {
			
			this.setState({ 
				dataCari: e.target.value, 
			});

			setTimeout(
				function() {
					this.fetch();
				}.bind(this),
				500
			);
		}
	}

	handleInputChange = (e, fld) => {
		this.setState({
			dt:{
				...this.state.dt,
				[fld]: e.target.value
			}
		});
	};

	handleSelectChange = (e, data) => {
		if (e) {
			this.setState({ 
				dt:{
					...this.state.dt,
					[data]: { value: e.value, label: e.label }
				}
			});
		} else {
			this.setState({ 
				dt:{
					...this.state.dt,
					[data]: "",
				}
			});
		}
	}

	detailData = (data) => {
		// this.state.status.btnAksi = true;
		this.setState({
			judul: "Detail Data Partner",
			status:{
				form: true,
				detail: true,
			},
			dt:{
				uuid:data.uuid,
				nama_usaha: data.nama_usaha,
				jenis_usaha: data.jenis_usaha,
				no_telp_usaha: data.no_telp_usaha,
				alamat_usaha: data.alamat_usaha,
				email_usaha: data.email_usaha,
				id_provinsi: data.data_kabkota.data_provinsi.nama,
				id_kabkota: data.data_kabkota.nama,
				nama_penanggung_jawab: data.nama_penanggung_jawab,
				no_telp_penanggung_jawab: data.no_telp_penanggung_jawab,
				email_penanggung_jawab: data.email_penanggung_jawab,
				file_ktp_penanggung_jawab: data.file_ktp_penanggung_jawab,
				file_npwp_perusahaan: data.file_npwp_perusahaan,
				file_siup_perusahaan: data.file_siup_perusahaan,
				no_siup: data.no_siup,
				no_npwp_perusahaan: data.no_npwp_perusahaan,
				alamat_perusahaan_npwp: data.alamat_perusahaan_npwp,
			}
		})
		this.forceUpdate();
		this.bukaForm('detail');
	}

	getFilePreview = (label, fileKey) => {
			
		const baseUrl = `https://digidesa.com/id/partners/file/`;
		const fileValue = this.state.dt[fileKey];

		if (!fileValue) {
			return <p>{label} Tidak Tersedia.</p>;
		}
		// const fileParse = data.file_siup_perusahaan;
		const fileUrl = baseUrl + fileValue;
		const fileExtension = fileValue.split('.').pop().toLowerCase();

		if (['png', 'jpg', 'jpeg'].includes(fileExtension)) {
			return (
			  <img
				src={fileUrl}
				alt={label}
				style={{ maxHeight: '330px', maxWidth: '100%', height: 'auto' }}
				readOnly={this.state.status.detail ? true : false}
			  />
			);
		  }
		
		  return (
			<a
			  href={fileUrl}
			  target="_blank"
			  rel="noopener noreferrer"
			  className="btn btn-primary"
			>
			  Download {label}
			</a>
		  );
	}

	bukaForm = (e) => {
		if (e === 'tambah') {
			this.setState({
				dt:formInput,
			})
		}
		this.setState ({
			status: {
				form: true,
			}
		});
		this.forceUpdate();
	}

	tutupForm = () => {
		this.setState({
			status: {
				form: false,
				btnForm: false,
				btnAksi: false,
				detail: false,
			},
			dt: formInput,
		})
		this.forceUpdate();
	}

	tombolAksi = (cell, row) => {
		return (
			<>
				<Button size="xs" color="primary" className="btn-eye" onClick={() => this.detailData(row)}><i className="fa fa-eye"></i></Button> &nbsp;&nbsp;
			</>
		)
	}
	componentDidMount() {
		this.fetch({ page: null, where: [] });
	}

	render() {
		var data = this.state.data;

		const columns = [
			{
				dataField: "no",
				text: "No",
				isDummyField: true,
				csvExport: false,
				headerAlign: 'center',
						align: 'center',
				formatter: (key, obj, index) =>{          
					let current_pagenum = this.state.pagination.current_page;
					let total_records_per_page = this.state.pagination.per_page;
					let row_index = (index+1);
					let serial_num = ((total_records_per_page*(current_pagenum-1))+row_index);
					return serial_num; 
				}
			},
			{
				dataField: 'nama_usaha',
				text: 'Nama Usaha',
				headerAlign: 'center',
				align: 'center',
				sort: true
			},
			{
				dataField: 'jenis_usaha',
				text: 'Jenis Usaha',
				headerAlign: 'center',
				align: 'center',
				sort: true
			},
			{
				dataField: 'alamat_usaha',
				text: 'Alamat Usaha',
				headerAlign: 'center',
				sort: true
			},
			{
				dataField: 'data_kabkota.nama',
				text: 'Kabupaten / Kota',
				headerAlign: 'center',
				align: 'center',
				sort: true
			},
			{
				dataField: 'nama_penanggung_jawab',
				text: 'Nama Penanggung Jawab',
				headerAlign: 'center',
				align: 'center',
				sort: true
			},
			{
				dataField: 'no_telp_penanggung_jawab',
				text: 'No. HP Penanggung Jawab',
				headerAlign: 'center',
				align: 'center',
				sort: true
			},
			{
				dataField: 'aksi',
				text: 'Aksi',
				headerAlign: 'center',
				align: 'center',
				isDummyField: true,
				csvExport: false,
				formatter: this.tombolAksi,
			},
		];

		return (
			<div>
				<Breadcrumb title="Data Partner" parent="Admin" />
				<SweetAlert
					show={this.state.show}
					type={this.state.basicType}
					title={this.state.basicTitle}
					confirmBtnBsStyle="success"
					onConfirm={this.closeAlert}
				>
					{this.state.pesanAlert}
				</SweetAlert>

				{this.state.alert}

				<div className="container-fluid">
					<div className="row">
						<div className="col-sm-12">
							<div className="card mb-0">
								<div className="card-body datatable-react">
									<div className="row">
										<div className="col-sm-6">
											<input
												type="search"
												className="form-control"
												id="cariTable"
												placeholder="Cari Disini..."
												defaultValue={this.state.dataCari}
												onKeyPress={this.cariData}
											/>
										</div>
										<div className="col-sm-6 text-right">
											{/* <Button 
												size="sm" 
												color="success" 
												className="btn-square" 
												onClick={() => {
													this.setState({ 
														judul: "Tambah Version App", 
														dt: formInput 
													}); 
													this.bukaForm('tambah'); 
												}}>
													Tambah Data
												</Button> */}
										</div>
									</div>

									<BootstrapTable
										keyField="uuid"
										data={data}
										columns={columns}
									/>
									<div className="pull-right text-white">
										{this.state.awal}
										{this.state.sebelum}
										{this.state.hal.map((dt) => {
											return dt;
										})}
										{this.state.setelah}
										{this.state.akhir}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<br />
				{/* Loading preview */}
				<SweetAlert
					show={this.state.loadingPreview}
					showCancel = {false}
					showConfirm={false}
				>
					<div align="center">
						<h5 className="modal-title" style={{ textAlign: "center", color: 'black' }}>Sedang memuat data...</h5>
						<br/>
						<img 
							alt="loading"
							src={require("../../assets/images/tes-loading.gif")} 
							style={{
								// width: "100%",
								borderRadius: "10px",
								width: '150px'
							}}
						/> 
						<br/><br/>
					</div>
				</SweetAlert>
				
				<Modal styles={{ modal: { width: "75%", maxWidth: 'unset' } }} open={this.state.status.form} onClose={this.tutupForm} closeOnEsc={false} closeOnOverlayClick={false}>
					<Form className="theme-form" onSubmit={this.simpan}>
						<div className="modal-header">
							<h5 className="modal-title">{this.state.judul}</h5>
						</div>
						<div className="modal-body">
							<input className="form-control" id="uuid" type="hidden" placeholder="UUID" defaultValue={this.state.dt.uuid} />
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Nama Usaha</Label>
								<Col sm='9'>
									<input 
										className="form-control" 
										id="nama_usaha" 
										type="text" 
										defaultValue={this.state.dt.nama_usaha} 
										onChange={e => this.handleInputChange(e, "nama_usaha")}
										required={true}
										readOnly={this.state.status.detail?true:false}
										style={this.state.status.detail ? { backgroundColor: "#F2F2F2" } : { backgroundColor: "" }}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Jenis Usaha</Label>
								<Col sm='9'>
									<input 
										className="form-control" 
										id="jenis_usaha" 
										type="text" 
										defaultValue={this.state.dt.jenis_usaha} 
										onChange={e => this.handleInputChange(e, "jenis_usaha")}
										required={true}
										readOnly={this.state.status.detail?true:false}
										style={this.state.status.detail ? { backgroundColor: "#F2F2F2" } : { backgroundColor: "" }}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">No. Telp. Usaha</Label>
								<Col sm='9'>
									<input 
										className="form-control" 
										id="no_telp_usaha" 
										type="text" 
										defaultValue={this.state.dt.no_telp_usaha} 
										onChange={e => this.handleInputChange(e, "no_telp_usaha")}
										required={true}
										readOnly={this.state.status.detail?true:false}
										style={this.state.status.detail ? { backgroundColor: "#F2F2F2" } : { backgroundColor: "" }}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Alamat Usaha</Label>
								<Col sm='9'>
									<input 
										className="form-control" 
										id="alamat_usaha" 
										type="text" 
										defaultValue={this.state.dt.alamat_usaha} 
										onChange={e => this.handleInputChange(e, "alamat_usaha")}
										required={true}
										readOnly={this.state.status.detail?true:false}
										style={this.state.status.detail ? { backgroundColor: "#F2F2F2" } : { backgroundColor: "" }}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Email Usaha</Label>
								<Col sm='9'>
									<input 
										className="form-control" 
										id="email_usaha" 
										type="text" 
										defaultValue={this.state.dt.email_usaha} 
										onChange={e => this.handleInputChange(e, "email_usaha")}
										required={true}
										readOnly={this.state.status.detail?true:false}
										style={this.state.status.detail ? { backgroundColor: "#F2F2F2" } : { backgroundColor: "" }}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Provinsi</Label>
								<Col sm='9'>
									<input 
										className="form-control" 
										id="id_provinsi" 
										type="text" 
										defaultValue={this.state.dt.id_provinsi} 
										onChange={e => this.handleInputChange(e, "id_provinsi")}
										required={true}
										readOnly={this.state.status.detail?true:false}
										style={this.state.status.detail ? { backgroundColor: "#F2F2F2" } : { backgroundColor: "" }}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Kab / Kota</Label>
								<Col sm='9'>
									<input 
										className="form-control" 
										id="id_kabkota" 
										type="text" 
										defaultValue={this.state.dt.id_kabkota} 
										onChange={e => this.handleInputChange(e, "id_kabkota")}
										required={true}
										readOnly={this.state.status.detail?true:false}
										style={this.state.status.detail ? { backgroundColor: "#F2F2F2" } : { backgroundColor: "" }}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Nama Penanggung Jawab</Label>
								<Col sm='9'>
									<input 
										className="form-control" 
										id="nama_penanggung_jawab" 
										type="text" 
										defaultValue={this.state.dt.nama_penanggung_jawab} 
										onChange={e => this.handleInputChange(e, "nama_penanggung_jawab")}
										required={true}
										readOnly={this.state.status.detail?true:false}
										style={this.state.status.detail ? { backgroundColor: "#F2F2F2" } : { backgroundColor: "" }}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">No. Telp. Penanggung Jawab</Label>
								<Col sm='9'>
									<input 
										className="form-control" 
										id="no_telp_penanggung_jawab" 
										type="text" 
										defaultValue={this.state.dt.no_telp_penanggung_jawab} 
										onChange={e => this.handleInputChange(e, "no_telp_penanggung_jawab")}
										required={true}
										readOnly={this.state.status.detail?true:false}
										style={this.state.status.detail ? { backgroundColor: "#F2F2F2" } : { backgroundColor: "" }}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Email Penanggung Jawab</Label>
								<Col sm='9'>
									<input 
										className="form-control" 
										id="email_penanggung_jawab" 
										type="text" 
										defaultValue={this.state.dt.email_penanggung_jawab} 
										onChange={e => this.handleInputChange(e, "email_penanggung_jawab")}
										required={true}
										readOnly={this.state.status.detail?true:false}
										style={this.state.status.detail ? { backgroundColor: "#F2F2F2" } : { backgroundColor: "" }}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">KTP Penanggung Jawab</Label>
								<Col sm='9'>
									{this.getFilePreview("KTP Penanggung Jawab", "file_ktp_penanggung_jawab")}
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">NPWP Perusahaan</Label>
								<Col sm='9'>
									{this.getFilePreview("NPWP Perusahaan", "file_npwp_perusahaan")}
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">SIUP Perusahaan</Label>
								<Col sm='9'>
									{this.getFilePreview("SIUP Perusahaan", "file_siup_perusahaan")}
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">No. SIUP</Label>
								<Col sm='9'>
									<input 
										className="form-control" 
										id="no_siup" 
										type="text" 
										defaultValue={this.state.dt.no_siup} 
										onChange={e => this.handleInputChange(e, "no_siup")}
										required={true}
										readOnly={this.state.status.detail?true:false}
										style={this.state.status.detail ? { backgroundColor: "#F2F2F2" } : { backgroundColor: "" }}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">No. NPWP Perusahaan</Label>
								<Col sm='9'>
									<input 
										className="form-control" 
										id="no_npwp_perusahaan" 
										type="text" 
										defaultValue={this.state.dt.no_npwp_perusahaan} 
										onChange={e => this.handleInputChange(e, "no_npwp_perusahaan")}
										required={true}
										readOnly={this.state.status.detail?true:false}
										style={this.state.status.detail ? { backgroundColor: "#F2F2F2" } : { backgroundColor: "" }}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Alamat Perusahaan NPWP</Label>
								<Col sm='9'>
									<input 
										className="form-control" 
										id="alamat_perusahaan_npwp" 
										type="text" 
										defaultValue={this.state.dt.alamat_perusahaan_npwp} 
										onChange={e => this.handleInputChange(e, "alamat_perusahaan_npwp")}
										required={true}
										readOnly={this.state.status.detail?true:false}
										style={this.state.status.detail ? { backgroundColor: "#F2F2F2" } : { backgroundColor: "" }}
									/>
								</Col>
							</FormGroup>
						</div>
						<div className="modal-footer">
							{
								this.state.status.detail?
								<button type="button" className="btn btn-warning" disabled={this.state.status.btnForm} onClick={this.tutupForm}>Tutup</button>
								:
								<></>
								// <button type="submit" className="btn btn-success" disabled={this.state.status.btnForm} onClick={this.simpan}>Simpan</button>
							}
						</div>
					</Form>
				</Modal>
			</div>
		)
	}
}


export default Partner;
